<template>
  <app-section-wrap :modifier="'login update-password'">
    <div column="xl-3">
      <password-validator
        v-model="passwordValid"
        :currentPasswordRequired="true"
        :currentPassword="currentPassword"
        :newPassword="newPassword"
        :confirmNewPassword="confirmNewPassword"
      />
    </div>

    <div column="xs-12 s-12 m-6 xl-6 ">
      <div class="card">
        <h1 class="_text-center _mbxs">
          New Password Required
        </h1>
        <div v-if="(authError || !mode)  && authMessage && authMessage.length" class="_flex justify-center">
        <p class="lips text" v-html="authMessage"></p>
      </div>
        <div v-if="authValue" class="_flex justify-center _text-center">
          <p class="lips text"> We just sent a code to your {{ mode ==='SMS'? `phone (${authValue.phone})`:  `email (${authValue.emailId})` }}</p>
        </div>

        <form @submit.prevent="updatePassword" method="POST">
          <div class="form-group">
            <div>
              <div class="flex-space-between">
                <label for="verificationToken">
                  Verification Code 
                </label> 
                <div>
                <font-awesome-icon v-if="requestingNewToken || retryingLogin" icon="spinner" pulse aria-label="Loading..."/>
                <a v-else @click="requestNewToken(mode)">Resend Code</a>
              </div>
              </div>
              
              <app-password-input
                id="verificationToken"
                name="verificationToken"
                value=""
                required
                v-model="verificationToken"
                autofocus="true"
                class="_mbxs"
              />
            </div>
            <p v-if="mode">
              Having Trouble? <a @click="$router.go(-1)"> Try another way </a>
            </p>
            <div>
              <label for="currentPassword">
                Current Password
              </label>
              <app-password-input
                id="currentPassword"
                name="currentPassword"
                minlength="6"
                value=""
                required
                v-model="currentPassword"
                class="_mbxs"
              />
            </div>
            <label for="newPassword">
              New Password
            </label>
            <app-password-input
              class="_mbxs"
              id="newPassword"
              name="newPassword"
              value=""
              required
              v-model="newPassword"
            />
            <label for="confirmNewPassword">
              Confirm New Password
            </label>
            <app-password-input
              id="confirmNewPassword"
              name="confirmNewPassword"
              value=""
              required
              v-model="confirmNewPassword"
            />
          </div>
          <async-button type="submit" class="_mtxs --sm" :executing="updatingPassword" :disabled="passwordValid || updatingPassword">
            <template #buttonContent>
              <span>Update Password</span>
            </template>
          </async-button>

        </form>
        <button v-if="newTokenSent"  class="white --sm" disabled >
          <span>
              {{ mode === "SMS"? 'Check Your Phone': 'Check Your Email' }} 
              <font-awesome-icon icon='check-circle' class='_mlxs' aria-label="Checkmark"/>
            </span>
        </button>
        <router-link to="/">Back to Sign In screen</router-link>
      </div>
    </div>

  </app-section-wrap>
</template>

<script>
  import AppSectionWrap from '@molecules/SectionWrap.vue'
  import AsyncButton from '@molecules/AsyncButton.vue'
  import PasswordValidator from '@organisms/PasswordValidator'
  import AppPasswordInput from '@atoms/PasswordInput'
  import { mapGetters } from 'vuex'
  import { UPDATE_PASSWORD } from '@store/modules/auth/actionTypes'
  import loginable from '@mixins/loginable'

  export default {
    mixins: [loginable],
    components: {
      AppSectionWrap,
      AsyncButton,
      AppPasswordInput,
      PasswordValidator
    },
    data() {
      return {
        passwordValid: true,
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
        verificationToken: '',
        newTokenSent: false,
      }
    },
    computed: {
      ...mapGetters([
        'authMessage',
        'authError',
        'updatingPassword',
        'userId',
        'requestingNewToken',
        'tokenUserMessage'
      ]),
      mode () {
        return this.$route.query.mode
      },
      formObject() {
        return {
          oldPassword: this.currentPassword,
          newPassword: this.newPassword,
          userId: this.userId,
          token: this.verificationToken,
          tokenMode: this.mode || 'EMAIL'
        }
      }
    },
    methods: {
      updatePassword () {
        this.$store.dispatch(UPDATE_PASSWORD, {
          body: this.formObject
        })
          .then(success => {
            if (success) {
              this.loginWithRetries({ userId: this.formObject.userId, password: this.formObject.newPassword })
            }
          })
      },
      requestNewToken (mode = 'EMAIL') {
        this.$store.dispatch('GET_NEW_TOKEN', {
          body: { userId: this.userId, tokenType: mode }
        })
          .then(success => {
            if (success) { this.newTokenSent = true } else {} // todo
          })
      }
    },
    created () {
      // Fire off a token request at the behest of EyeMed IT
      if (!this.mode) {
        this.requestNewToken()
      }
    }
  }
</script>
<style scoped>
.flex-space-between{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
